import { useQueryParam } from '../../hooks/useQueryParam';

export function useIsOverlay() {
  const isOverlay = useQueryParam('overlay');
  if (!isOverlay) return false;

  return parseInt(isOverlay) === 1;
}
